import { render, staticRenderFns } from "./couponTemplate.vue?vue&type=template&id=001c22c4&scoped=true"
import script from "./couponTemplate.vue?vue&type=script&lang=js"
export * from "./couponTemplate.vue?vue&type=script&lang=js"
import style0 from "./couponTemplate.vue?vue&type=style&index=0&id=001c22c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001c22c4",
  null
  
)

export default component.exports